import CitySEOHead from "@/components/feature/CitySEOHead";
import HeroSection from "./components/HeroSection";
import StickyNav from "./components/StickyNav";
import ProcessingTimeSection from "./components/ProcessingTimeSection";
import ServicesSection from "./components/ServicesSection";
import HowItWorksSection from "./components/HowItWorksSection";
import LocalAreaSection from "./components/LocalAreaSection";
import TestimonialsSection from "./components/TestimonialsSection";
import AcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import ComparisonSection from "./components/ComparisonSection";
import MistakesSection from "./components/MistakesSection";
import FAQSection from "./components/FAQSection";
import HelpfulResourcesSection from "./components/HelpfulResourcesSection";
import FinalCTA from "./components/FinalCTA";

const pageTitle = "Emergency Passport Bismarck, ND — Expedited & Fast Passport Service | Fast Passport Center";
const pageDescription = "Fast Passport Center provides emergency, expedited, and same-day passport services in Bismarck, North Dakota. Serving Burleigh County, Mandan, Lincoln, and surrounding communities. As fast as 24 hours — no Denver or Chicago agency trip needed.";

export default function BismarckPage() {
  return (
    <>
      <CitySEOHead
        city="Bismarck"
        state="North Dakota"
        stateAbbr="ND"
        route="/cities/bismarck"
        title="Emergency Passport Bismarck, ND — Expedited & Fast Passport Service | Fast Passport Center"
        description={pageDescription}
        ogTitle={pageTitle}
        ogDescription={pageDescription}
        twitterTitle={pageTitle}
        twitterDescription={pageDescription}
        geoPlacename="Bismarck, North Dakota"
        geoPosition="46.8083;-100.7837"
        keywords="expedited passport Bismarck, emergency passport Bismarck ND, same day passport Bismarck, fast passport North Dakota, passport renewal Bismarck, Burleigh County passport"
        faqs={[]}
        servicesSchema={[]}
        statePageName="North Dakota"
        statePageRoute="/states/north-dakota"
        lastModified="2026-06-09"
        serviceAreaDesc="Expedited and emergency passport services for Bismarck, ND and Burleigh County. As fast as 24 hours. No Denver or Chicago agency trip needed."
      />

      <div className="min-h-screen bg-white">
        <HeroSection />
        <StickyNav />
        <ProcessingTimeSection />
        <LocalAreaSection />
        <ServicesSection />
        <HowItWorksSection />
        <TestimonialsSection />
        <AcceptanceFacilitiesSection />
        <ComparisonSection />
        <MistakesSection />
        <FAQSection />
        <HelpfulResourcesSection />
        <FinalCTA />
      </div>
    </>
  );
}